import BrandSpecialPricing from './components/BrandSpecialPricing';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import get from 'lodash/get';
import { connect } from 'react-redux';

import { updateBrand ,loadAgency, loadBrand } from '../../shared/redux/entities/actions'

import {
  ADJOY_DEFAULT_CHOOSE_COST,
  ADJOY_DEFAULT_THIS_OR_THAT_COST,
  ADJOY_DEFAULT_RATABLE_COST,
  ADJOY_DEFAULT_REVENUE_SPLIT,
  ADJOY_DEFAULT_QA_COST
} from '../../config';

function mapStateToProps(state,props){
  const brandId = props.brandId,
    agencyId = get(state,['entities','companies',brandId,'agencyId']);

  return {
    brandId:brandId,
    agencyId:agencyId,
    chooseDefaultCost:get(state,['entities','companies',brandId,'chooseDefaultCost']),
    defaultChooseDefaultCost:get(state,['entities','agencies',agencyId,'chooseDefaultCost']) || ADJOY_DEFAULT_CHOOSE_COST,
    ratableDefaultCost:get(state,['entities','companies',brandId,'ratableDefaultCost']),
    defaultRatableDefaultCost:get(state,['entities','agencies',agencyId,'ratableDefaultCost']) || ADJOY_DEFAULT_RATABLE_COST,
    defaultRevenueSplit:get(state,['entities','companies',brandId,'defaultRevenueSplit']),
    defaultDefaultRevenueSplit:get(state,['entities','agencies',agencyId,'defaultRevenueSplit']) || ADJOY_DEFAULT_REVENUE_SPLIT,
    thisOrThatDefaultCost:get(state,['entities','companies',brandId,'thisOrThatDefaultCost']),
    defaultThisOrThatDefaultCost:get(state,['entities','agencies',agencyId,'thisOrThatDefaultCost']) || ADJOY_DEFAULT_THIS_OR_THAT_COST,
    qaDefaultCost:get(state,['entities','companies',brandId,'qaDefaultCost']),
    defaultQADefaultCost:get(state,['entities','agencies',agencyId,'qaDefaultCost']) || ADJOY_DEFAULT_QA_COST,
    defaultCostPerCompletion:get(state,['entities','companies',brandId,'defaultCostPerCompletion'],0),
    useCostPerCompletion:get(state,['entities','companies',brandId,'useCostPerCompletion'],false) 
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ updateBrand, loadAgency, loadBrand },dispatch);
}



export default withRouter(connect(mapStateToProps,mapDispatchToProps)(BrandSpecialPricing));



// WEBPACK FOOTER //
// ./src/routes/BrandSpecialPricing/index.js